import FormInput from "@babackapp/react-hook-forms-components/form-input";
import { FormField } from "@babackapp/ui/components/form";
import { useFieldArray, useFormContext } from "react-hook-form";
import { ReturnReasonFormValues } from "./add-return-reason-dialog";

export default function ReturnReasonTranslationsForm() {
  const { control } = useFormContext<ReturnReasonFormValues>();

  const translations = useFieldArray({
    control,
    name: "values",
  });

  return (
    <div className="pt-8 flex flex-col gap-8">
      {translations.fields.map((field, index) => (
        <FormField
          key={field.id}
          control={control}
          rules={{ validate: (value) => value.trim().length > 0 }}
          name={`values.${index}.text`}
          render={({ field: { value, onChange } }) => (
            <FormInput label={field.lang} value={value} onChange={onChange} />
          )}
        />
      ))}
    </div>
  );
}
